<template>
	<div class="memberCenter layui-layout layui-layout-admin" style="background:#fff;" v-show='show'>
		<div class="layui-header al_itm" style="background:#fff;z-index: 2;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				<i @click="setClass(1)" v-if="showClass!=1" class="layui-icon-left layui-icon px20 pointer" style="margin-right:20px;"></i> {{showClass==1?'会员中心':'充值'}}
				<button @click="onRecord" v-if="showClass==2" class="layui-btn" style="background: #4876FF; margin-left: 20px;">充值记录</button>
			</div>
		</div>
		<!-- 会员中心模块 -->
		<div v-show="showClass==1">
			<div class="f_row al_itm border_b">
				<div class="f_col al_itm jc_ct" style="width:max-content;margin:10px 12px 10px;">
					<img src="../assets/logo.png" class="rds_50" height="120" width="120" alt="">
				</div>
				<div style="padding-bottom: 40px;">
					<div class="f_row al_itm px18" style="height:30px;">
						<span style="margin-left:10px;">欢迎您 {{userInfo.company_name}}</span>
					</div>
					<div class="f_row al_itm px16" style="height:30px;" v-if="pay_type == 1">
						<span style="margin-left:10px;">{{userInfo.grade_name}}</span>
						<div class="f_row al_itm" style="padding: 12px 12px 12px 30px;">
							<div class="f_row al_itm">
								<span @click="onScore" style="margin-left:10px;" class="pointer">桃币：{{userInfo.score ? userInfo.score : 0}}</span>
							</div>
							<button v-if="is_sub == 0" @click="setClass(2)" class="layui-btn" style="background: #4876FF; margin-left: 20px; width: 80px;">充值</button>
							<button v-if="is_sub == 0" @click="onRecord" class="layui-btn" style="background: #4876FF; margin-left: 20px;">充值记录</button>
						</div>
					</div>
					<div class="f_row al_itm relet" style="width:100%;margin-top:15px;" v-if="pay_type == 1">
						<div class="layui-progress" style="width:180px;height:15px;position: relative;" lay-filter="bar">
							<div class="layui-progress-bar" style="height:15px;" lay-percent="0%"></div>
							<p class="exp">{{userInfo.recharge_amount}} / {{userInfo.exp_end}}</p>
						</div>
						<el-popover placement="right" title="" width="800" trigger="click">
							<div v-html="level_txt"></div>
							<div class="explain" slot="reference">【等级说明】</div>
						</el-popover>
					</div>
				</div>
			</div>
			<div class="banner">
				<el-carousel :interval="4000" type="card" height="400px" trigger="click" arrow="always">
					<el-carousel-item>
						<img src="../assets/banner/img4.jpg" />
					</el-carousel-item>
					<el-carousel-item>
						<img src="../assets/banner/img5.jpg" />
					</el-carousel-item>
					<el-carousel-item>
						<img src="../assets/banner/img6.jpg" />
					</el-carousel-item>
					<el-carousel-item>
						<img src="../assets/banner/img7.jpg" />
					</el-carousel-item>
					<el-carousel-item>
						<img src="../assets/banner/img8.jpg" />
					</el-carousel-item>
					<el-carousel-item>
						<img src="../assets/banner/img9.jpg" />
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
		<!-- 充值 -->
		<div v-show="showClass==2">
			<div class="border_b" style="padding:10px 30px;">
				<div style="line-height: 1.5;" v-html="recharge_text"></div>
			</div>
			<div class="f_row al_itm jc_sb" style="padding: 12px 12px 30px 30px;">
				<div class="f_row al_itm">
					<img src="../assets/logo.png" class="rds_50" height="40" width="40" alt="">
					<span style="margin-left:20px;" class="px16">桃币 {{userInfo.score ? userInfo.score : 0}}</span>
				</div>
			</div>
			<div class="f_row al_itm" style="padding: 12px 12px 30px 30px;">
				<div class="px16" style="margin-right:20px;min-width:70px;margin-bottom: 5px;">金&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;额</div>
				<div class="layui-btn-container">
					<button type="button" @click="setMon(i,item)" :class="'layui-btn layui-btn-primary '+ (i == clasIndex?'currents':'')" v-for="(item,i) in monClass">{{item.title}}</button>
				</div>
			</div>
			<div class="f_row al_itm" style="padding: 12px 12px 30px 30px;" v-if="score || frames">
				<div class="px16" style="margin-right:20px;min-width:70px;margin-bottom: 5px;">赠&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;送</div>
				<div class="layui-btn-container">
					<button type="button" v-if='score != 0' @click="selGifts('score')" :class="'layui-btn layui-btn-primary ' + (is_score == 'score' ? 'currents':'')">赠送{{score}}桃币</button>
					<button type="button" v-if='frames != 0' @click="selGifts('frame')" :class="'layui-btn layui-btn-primary ' + (is_score == 'frame' ? 'currents':'')">赠送{{frames}}个网框</button>
				</div>
			</div>
			<div class="f_row al_itm" style="padding: 12px 12px 30px 30px;">
				<div class="px16" style="margin-right:20px;min-width:70px;">支付方式</div>
				<div @click="setPayclass(i)" style="margin-right:40px;" class="f_row al_itm pointer px16" v-for="(item,i) in payClass" :key="i">
					<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
					<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 zt_txt_color"></i>
					<img class="icons" v-if="item.id == 1" src="../assets/wchat.png" height="28" width="28" alt="">
					<img class="icons" v-if="item.id == 2" src="../assets/aply.png" height="28" width="28" alt="">
					<img class="icons" v-if="item.id == 3" src="../assets/ylian.png" height="28" width="28" alt="">
					<span>{{item.clas}}</span>
				</div>
			</div>
			<div class="f_row al_itm" style="padding: 12px 12px 36px 30px;">
				<div class="px16" style="margin-right:20px;min-width:70px;">合&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;计</div>
				<div style="margin-right:40px;" class="f_row al_itm px16">
					<span style="margin-left:10px;" class="mon_color">¥ {{allMoney}}</span>
				</div>
			</div>
			<button type="button" class="layui-btn zt_color px16" style="width:390px;margin-left:115px;" @click="rechargeOrder">确定充值</button>
		</div>
		<el-dialog title="《等级说明》" :visible.sync="explain" width="60%" :modal="false" :close-on-click-modal='false' :close-on-press-escape='false' center>
			<div v-if="explain" style="height: 500px;overflow: auto;" v-html="level_txt"></div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="explain = false">取 消</el-button>
				<el-button type="primary" @click="explain = false">确定</el-button>
			</div>
		</el-dialog>
		<!--弹出层-->
		<div class="layer" v-if='imgShow'></div>
		<div id="qrCode" style="display: none;">
			<img :src="'https://mr.summary88.com/'+imgUrl" />
			<p>请打开微信扫码支付</p>
		</div>
		<div id="record" style="display: none;">
			<table class="layui-table" style="width:100%;margin:0;">
				<thead>
					<tr>
						<th class="align_center">序号</th>
						<th class="align_center">订单编号</th>
						<th class="align_center">充值金额</th>
						<th class="align_center">支付方式</th>
						<th class="align_center">日期</th>
						<th class="align_center">备注</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,i) in recordList" :key="i">
						<td class="align_center">
							{{i+1}}
						</td>
						<td class="align_center">{{item.order_num}}</td>
						<td class="align_center">{{item.order_money}}</td>
						<td class="align_center">{{item.pay_type}}</td>
						<td class="align_center">{{item.pay_time}}</td>
						<td class="align_center">{{item.remarks}}</td>
					</tr>
					<tr v-if="recordList.length == 0">
						<td style="padding: 5px 30px 0;text-align: center;line-height: 50px;" colspan="6">暂无数据</td>
					</tr>
				</tbody>
			</table>
			<el-button class="closeBtn" type="primary" @click="onCloseRecord">关闭</el-button>
		</div>
		<div id="forms"></div>
	</div>
</template>

<script>
	export default {
		name: 'memberCenter',
		data() {
			return {
				explain: false,
				userInfo: '',
				show: false,
				showClass: 1,
				tables: '',
				clasIndex: 0,
				allMoney: 0,
				monClass: [],
				payClass: [{
						id: 1,
						clas: '微信支付',
						checked: true
					},
					{
						id: 2,
						clas: '支付宝支付',
						checked: false
					},
					{
						id: 3,
						clas: '银联支付',
						checked: false
					}
				],
				imgUrl: '',
				imgShow: false,
				clear: '',
				is_sub: 0,
				score: 0,
				frames: 0,
				is_score: '',
				recharge_text: '',
				level_txt: '',
				recordList: [],
				pay_type: 0,
			}
		},
		created() {
			let _this = this;
			api.copywriting({
				token: _this.getCookie('token')
			}).then((res) => {
				if(res.code == 1) {
					_this.recharge_text = res.data.content;
				}
			});
			api.memberLevel({

			}).then((res) => {
				if(res.code == 1) {
					_this.level_txt = res.data.content;
				}
			});
		},
		mounted() {
			this.getData()
		},
		methods: {
			getData() {
				let _this = this;
				layui.use(['element', 'layer'], function() {
					var element = layui.element;
					api.getMemberInfo({ //获取会员信息
						token: _this.getCookie('token')
					}).then((res) => {
						if(res.code == 1) {
							_this.pay_type = res.data.pay_type;
							_this.is_sub = res.data.is_sub;
							_this.userInfo = res.data;
							let percent = parseFloat((res.data.recharge_amount - res.data.exp_start) / (res.data.exp_end - res.data.exp_start)) *
								100;
							percent = parseInt(percent) + '%';
							element.progress('bar', percent);
							api.recharge({ //首充和续充设置接口接口
								token: _this.getCookie('token'),
								recharge_id: res.data.recharge_id,
								type: 1
							}).then((res1) => {
								if(res1.code == 1) {
									_this.monClass = res1.data;
									_this.score = res1.data[0].score;
									_this.frames = res1.data[0].frame;
									if(_this.score) {
										_this.is_score = 'score'
									} else {
										_this.is_score = 'frame'
									}
									_this.allMoney = res1.data[0].money;
								}
								_this.show = true;
							});
						} else if(res.code == 0) {
							layer.msg(res.msg, {
								icon: 2,
								anim: 6
							})
						}
					});
				});
			},
			selGifts(type) {
				this.is_score = type;
			},
			setMon(e, item) {
				this.clasIndex = e;
				this.allMoney = item.money;
				this.score = item.score;
				this.frames = item.frame;
			},
			setPayclass(e) {
				this.payClass.forEach((v) => {
					v.checked = false;
				});
				this.payClass[e].checked = true;
			},
			setClass(e) {
				this.showClass = e;
			},
			onScore() {
				this.$router.push({
					path: '/memberLog'
				})
			},
			rechargeOrder() {
				let _this = this;
				let type = 0;
				for(var i = 0; i < this.payClass.length; i++) {
					if(this.payClass[i].checked) {
						type = this.payClass[i].id;
						break;
					}
				}
				if(type == 3) {
					alert('暂未开通')
					return false;
				}
				let give = 3; //1是积分2是网框3是没赠送
				if(this.is_score == 'score') {
					give = 1;
				}
				if(this.is_score == 'frame') {
					give = 2;
				}
				let obj = {
					token: this.getCookie('token'),
					order_money: this.monClass[this.clasIndex].money,
					share_score: this.monClass[this.clasIndex].score,
					frame: this.frames,
					pay_type: type,
					recharge_id: 0,
					continued_id: 0,
					give_type: give,
				}
				if(this.userInfo.recharge_id) {
					obj.continued_id = this.monClass[this.clasIndex].id;
				} else {
					obj.recharge_id = this.monClass[this.clasIndex].id;
				}
				api.rechargeOrder(obj).then((res) => {
					if(res.code == 1) {
						_this.onPay(res.data);
					} else if(res.code == 0) {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				})
			},
			onPay(num) {
				let _this = this;
				api.pay({
					token: this.getCookie('token'),
					order_num: num
				}).then((res) => {
					if(res.code == 1) {
						if(res.type == 'wechat') {
							_this.imgUrl = res.data;
							_this.imgShow = true;
							layui.use(['layer'], () => {
								setTimeout(() => {
									layer.open({
										title: '支付',
										type: 1,
										content: $('#qrCode'),
										resize: false,
										shadeClose: true,
										success: function() {
											_this.verify(num);
										},
										cancel: function(index, layero) {
											_this.imgShow = false;
											clearInterval(_this.clear);
										}
									});
								}, 100)
							});
						}
					} else if(res.code == 0) {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					} else {
						let divForm = document.getElementsByTagName('divform')
						if(divForm.length) {
							document.body.removeChild(divForm[0])
						}
						const div = document.createElement('divform');
						div.innerHTML = res; // data就是接口返回的form 表单字符串
						document.body.appendChild(div);
						document.forms[0].submit();
					}
				})
			},
			verify(num) {
				var _this = this;
				var i = 0;
				clearInterval(_this.clear);
				_this.clear = setInterval(() => {
					i++;
					api.returnx({
						token: this.getCookie('token'),
						order_num: num
					}).then((res) => {
						if(res.code == 1) {
							clearInterval(_this.clear);
							_this.getData();
							layer.closeAll();
							_this.imgShow = false;
							layer.msg('支付成功', {
								icon: 1,
								anim: 5
							})
						} else {
							if(i == 100) {
								clearInterval(_this.clear);
								layer.closeAll();
								layer.msg('支付超时', {
									icon: 2,
									anim: 6
								})
							}
						}
					})
				}, 3000)
			},
			onRecord() {
				let _this = this;
				api.record({
					token: this.getCookie('token'),
					type: 1
				}).then((res) => {
					_this.imgShow = true;
					_this.recordList = res.data || [];
					layui.use(['layer'], () => {
						setTimeout(() => {
							layer.open({
								title: '充值记录',
								type: 1,
								content: $('#record'),
								shade: 0,
								area: '1200px',
								success: function() {

								},
								cancel: function(index, layero) {
									_this.imgShow = false;
								}
							});
						}, 100)
					});
				})
			},
			onCloseRecord() {
				this.imgShow = false;
				layer.closeAll();
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#record {
		padding: 20px;
	}
	
	.closeBtn {
		display: block;
		margin: 20px auto 0;
	}
	
	.exp {
		font-size: 14px;
		position: absolute;
		bottom: -150%;
		left: 50%;
		transform: translateX(-50%);
		white-space: nowrap;
	}
	
	.layer {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.3);
		z-index: 10000;
	}
	
	.memberCenter {
		font-family: SourceHanSansSC;
	}
	
	.currents {
		border-color: #4876FF;
		color: #4876FF;
	}
	
	.btns {
		color: #fff;
		font-size: 16px;
		width: 95px;
		height: 40px;
		border-radius: 4px;
		margin-left: 20px;
	}
	
	.dscBox {
		position: absolute;
		color: #fff;
		padding: 10px;
		box-sizing: border-box;
		background: rgba(0, 0, 0, 0.7);
		width: 442px;
		height: 531px;
		right: -465px;
		top: 0px;
		border-radius: 5px;
	}
	
	.editBtns {
		color: #ccc;
		font-size: 18px;
		font-weight: 100;
		border-color: #ccc;
		border: 1px solid;
		width: 40px;
		text-align: center;
		line-height: 20px;
	}
	
	.icons {
		margin-left: 10px;
	}
	
	#qrCode {
		width: 300px;
		padding: 20px 20px 50px;
	}
	
	#qrCode img {
		display: block;
		width: 300px;
		height: 300px;
		margin-bottom: 30px;
	}
	
	#qrCode p {
		font-size: 16px;
		text-align: center;
	}
	
	.banner {
		margin: 50px auto 0;
		padding: 0 40px;
		box-sizing: border-box;
		max-width: 1640px;
	}
	
	.banner img {
		width: 780px;
		height: 400px;
	}
	
	.explain {
		color: rgba(72, 118, 255, 1);
		margin-left: 10px;
		font-size: 16px;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/components/memberCenter.vue